import Joi from "joi";
import { useDictionary } from "../../contexts/dictionary";
import { BoxContainer, Col, HeroBanner, List, ListItem, Row, TabButtons, TabButtonsItem, Text, Title, VerticalSeparator, VImage } from "../../style/base.style";
import { Colors } from "../../style/colors";



import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useDeviceType } from "../../contexts/DeviceContext";
import { FieldType, TextFieldType } from "../fields";
import { VerticalSepWithTitle } from "../common/verticalSepWithTitle";
import { FormComponent } from "../form";
import { ActionButton } from "../buttons/ActionButton";
import { useFormHandling } from "../../hooks/formUtils";
import { EmailPasswordAuthNew, OtpAuth, PhoneAuthNew } from "../../hooks/socialAuth";
import { useEffect, useState } from "react";
import { RequestConfigs } from "../../api";
import { SocialAuthComponent } from "../socialAuth";
import { TextLink } from "../common/TextLink";
import { useContactType } from "../../contexts/ContactContext";
import { routesMap } from "../../constants/routes";
import { useVendorType } from "../../contexts/VendorContext";

interface RegistrationProps {
  currentForm?: "registration" | "login"
  nextPage?: string
}


export const PartnerLoginComponent = ({ currentForm, nextPage }: RegistrationProps) => {

  
  const { translate } = useDictionary()
  const { isMobile } = useDeviceType()
  const {vendor} = useVendorType()
  const navigate = useNavigate();

    const [searchParams] = useSearchParams();
  const email = searchParams.get("Email");
  const password = searchParams.get("Password");
  console.log(email, password,"email and password");




  const passwordLoginFields: FieldConfig[] = [

    {
      type: FieldType.text,
      name: "Email",
      label: translate("email_label"),
      joiSchema: Joi.string().email({ tlds: { allow: false } }).required(),
      typeOptions: {
        type: TextFieldType.text,
      }
    },

    {
      type: FieldType.text,
      name: "Password",
      label: translate("password_label"),
      joiSchema: Joi.string().required(),
      typeOptions: {
        type: TextFieldType.password,
      }
    },
  ]


  useEffect(() => {
    if (email && password) {
      handleInputChange("Email", email,true);
      handleInputChange("Password", password,true);
    }

  }  , [email, password]);


  useEffect(() => {

  },[])


  
  const { handleInputChange, handleClick, serverRes,formValues } = useFormHandling({ requestType: RequestConfigs.vendorLogin })

  useEffect(() => {
    if(formValues && formValues.Email && formValues.Password && email && password) {
      handleClick(); // Automatically submit the form if email and password are provided
      
    }
    
  },[formValues])


  useEffect(()=>{
    if(vendor) {
      navigate(routesMap.searchMember.to);
    }
  },[vendor])

  

  return (
    <Col style={{ maxWidth: '500px',minWidth: '400px', padding: '40px' }} $width={isMobile ? "100%" : "60%"} $border={`1px solid${Colors.fieldBorder}`} $borderRadius={10} $backgroundColor={Colors.whiteBackground} $gap={10} $padding="20px">
      <Title $fontSize={24}>{translate('login')}</Title>
     
      <FormComponent
        fields={passwordLoginFields}

        onChange={handleInputChange}
        serverRes={serverRes}
      />
      <p>

      </p>
      <ActionButton onClick={handleClick} width="100%" route="#" label={translate('login')} />

    
      
    

    </Col>

  )

};